import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.modalConfig.visible,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalConfig.visible) = $event)),
    title: _ctx.modalConfig.title,
    onOk: _ctx.handleOk
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.formState,
        rules: _ctx.rules,
        "label-col": { style: { width: '110px' } }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "机身号",
            name: "serial"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.serial,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.serial) = $event)),
                placeholder: "机身号",
                allowClear: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "生产日期",
            name: "localDate"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_date_picker, {
                value: _ctx.formState.localDate,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.localDate) = $event)),
                placeholder: "生产日期",
                allowClear: "",
                onChange: _ctx.handleSelectDate
              }, null, 8, ["value", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "型号规格",
            name: "modelSpecifications"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_cascader, {
                value: _ctx.modelSpecifications,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelSpecifications) = $event)),
                options: _ctx.modelSpecificationsOption,
                onChange: _ctx.handleSelectModel,
                allowClear: "",
                placeholder: "请选择型号规格"
              }, null, 8, ["value", "options", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "生产批号",
            name: "batchNumber"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.batchNumber,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.batchNumber) = $event)),
                placeholder: "请输入生产批号 例SCBDKA",
                allowClear: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["visible", "title", "onOk"]))
}